import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { BackendResponse } from '../../shared/backend-response.model';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent extends ComponentView {

    fb = inject(FormBuilder);

    form: FormGroup;

    running = false;
    done = false;
    resultType: 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' | undefined = null;
    resultMessage = "";

    async initParams(): Promise<boolean> {
        this.form = this.fb.group({
            userName: ['', Validators.required],
            password: ['', Validators.required],
            passwordRepeat: ['', Validators.required]
        });
        return Promise.resolve(true);
    }

    async send(): Promise<void> {
        this.running = true;
        try {
            await RestEndpoint.main().contentTypeForm().post().body({userName: this.form.get("userName").value, password: this.form.get("password").value}).run("api/app/auth/register").get(BackendResponse);
            this.resultType = "success";
            this.resultMessage = "Die Registrierung war erfolgreich. Bitte schauen Sie in ihrem E-Mail Postfach nach der Aktivierungs-Mail";
        }
        catch (ex) {
            this.resultType = "danger";
            this.resultMessage = "Die Registrierung war nicht erfolgreich. " + BackendResponse.getFromException(ex).items[0].message;
        }
        this.running = false;
        this.done = true;
    }

    async cancel(): Promise<void> {

    }
}
